export default "__VITE_ASSET__gsNyRJzT__"